import React, { Component } from 'react';
import styled from 'styled-components';
import Link from 'valuelink';

import ProgressBar from '../../components/common/ProgressBar';
import { PrimaryButton } from '../../components/common/Buttons';
import {
  getHraForm,
  submitHraResponse,
  goToPreviousHra,
  resetHra,
} from '../../services';
import MultipleSelect from '../../components/hra/MultipleSelect';
import SingleSelect from '../../components/hra/SingleSelect';
import StringInput from '../../components/hra/StringInput';
import StartScreen from './HraStartContainer';

import backIcon from '../../images/hra/back.svg';
import nextIcon from '../../images/hra/next.svg';
import arrowUpWhite from '../../images/common/arrow-up-white.svg';
import crossIcon from '../../images/common/cross-purple.svg';
import { connect } from 'react-redux';

const BodyContainer = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  align-items: stretch;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
`;

const ButtonsContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 20px 20px;
  margin: 0px 4px;
  position: relative;
  border: 1px solid #c4b8fd;
  border-radius: 50px;
  border-opacity: 0.2;
`;

class HraQuestionContainer extends Component {
  constructor(props) {
    super(props);

    this.state = {
      currentQuestion: null,
      end: false,
      userResponse: null,
      stringResponse: '',
      showInfo: false,
      age: '',
      gender: '',
    };
    this.containerRef = React.createRef();
  }

  componentDidMount() {
    const { history } = this.props;
    if (this.props.config.showUpdatedHra) {
      this.setState({
        showInfo: true,
      });
    }
    return Promise.resolve()
      .then(() => {
        const parsedUrl = new URL(window.location.href);
        if (parsedUrl.searchParams.get('reset')) {
          return resetHra();
        }
        return Promise.resolve();
      })
      .then(() => {
        return getHraForm()
          .then((res) => {
            if (res.message === 'success') {
              this.setState({
                currentQuestion: res.question,
              });
              if (
                res.age &&
                res.question.questionId === 2 &&
                !res.userResponse
              ) {
                this.setState({
                  stringResponse: String(res.age),
                });
              }
              if (
                res.gender &&
                res.question.questionId === 1 &&
                !res.userResponse
              ) {
                this.setState({
                  userResponse: String(res.gender),
                });
              }
            } else if (res.message === 'end') {
              history.replace('/hra/end', {
                from: this.props?.location?.state?.from,
              });
            }
          })
          .catch((err) => {
            console.log(err);
          });
      });
  }

  findOptionIndex(option) {
    const { userResponse } = this.state;
    console.log(userResponse, option);
    if (!userResponse || !Array.isArray(userResponse)) {
      return -1;
    }
    return userResponse.findIndex((ele) => ele === option);
  }

  setResponse = (res) => {
    const { type } = this.state.currentQuestion;
    const { userResponse } = this.state;
    console.log(type, res);
    switch (type) {
      case 'multiple_select': {
        const index = this.findOptionIndex(res);
        if (index === -1) {
          console.log('-1');
          // Add the response
          if (res === 'None of the above') {
            this.setState({
              userResponse: [res],
            });
          } else if (Array.isArray(userResponse)) {
            const updatedResponses = userResponse.filter(
              (ele) => ele !== 'None of the above'
            );
            this.setState({
              userResponse: updatedResponses.concat([res]),
            });
          } else {
            this.setState({
              userResponse: [res],
            });
          }
        } else {
          // Remove the response
          console.log('Remove the response');
          const updatedUserResponse = Array.from(userResponse);
          updatedUserResponse.splice(index, 1);
          console.log(updatedUserResponse);
          this.setState({
            userResponse: updatedUserResponse,
          });
        }
        break;
      }
      case 'single_select': {
        this.setState({
          userResponse: res,
        });
        break;
      }
      default:
        break;
    }
  };

  submitResponse = (res) => {
    console.log(res, 'submitResponse');
    const { userResponse, stringResponse, currentQuestion } = this.state;
    const { history } = this.props;
    this.setState({
      userResponse: '',
      stringResponse: '',
    });
    const body = {
      questionId: currentQuestion.questionId,
      questionOrder: currentQuestion.questionOrder,
      choice:
        res ||
        (currentQuestion.type === 'text_input' ? stringResponse : userResponse),
      type: currentQuestion.type,
      parentOrder: currentQuestion.parentOrder,
      conditional: currentQuestion.conditional,
      title: currentQuestion.title,
    };

    submitHraResponse(body)
      .then((res) => {
        if (res.message === 'success') {
          this.setState({
            currentQuestion: res.question,
            userResponse: res.userResponse || '',
            stringResponse:
              res.question.type === 'text_input' && res.userResponse
                ? res.userResponse
                : '',
          });
          if (res.age && res.question.questionId === 2 && !res.userResponse) {
            this.setState({
              stringResponse: String(res.age),
            });
          }
          if (
            res.gender &&
            res.question.questionId === 1 &&
            !res.userResponse
          ) {
            this.setState({
              userResponse: String(res.gender),
            });
          }
        } else if (res.message === 'end') {
          history.replace('/hra/end', {
            from: this.props?.location?.state?.from,
          });
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  goToPrevious = () => {
    const { parentOrder, questionOrder } = this.state.currentQuestion;
    const { history } = this.props;
    this.containerRef.current.scrollTo(0, 0);
    goToPreviousHra(parentOrder, questionOrder)
      .then((res) => {
        if (res.message === 'success') {
          this.setState({
            currentQuestion: res.question,
            userResponse: res.userResponse,
            stringResponse:
              res.question.type === 'text_input' && res.userResponse
                ? res.userResponse
                : '',
          });
        } else if (res.message === 'end') {
          history.replace('/hra/end', {
            from: this.props?.location?.state?.from,
          });
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  resetHra = () => {
    const { history } = this.props;
    resetHra()
      .then((res) => {
        if (res.message === 'success') {
          this.setState({
            end: false,
            currentQuestion: res.question,
            userResponse: '',
            stringResponse: '',
          });
        } else if (res.message === 'end') {
          history.replace('/hra/end', {
            from: this.props?.location?.state?.from,
          });
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  render() {
    const { currentQuestion, userResponse, showInfo } = this.state;
    if (!currentQuestion) {
      return false;
    }
    const {
      // currentOrder,
      questionOrder,
      parentOrder,
      title,
      text,
      type,
      options,
      // totalQuestions,
      info,
    } = currentQuestion;
    if (questionOrder === 1 && parentOrder === 0) {
      return (
        <StartScreen
          submitResponse={this.submitResponse}
          from={this.props?.location?.state?.from}
        />
      );
    }
    console.log(userResponse);
    const responseLink = Link.state(this, 'stringResponse');
    const progress =
      ((currentQuestion.currentProgress.totalSections -
        currentQuestion.currentProgress.remainingSections) /
        currentQuestion.currentProgress.totalSections) *
      100;
    const renderResponse = () => {
      switch (type) {
        case 'single_select':
          return (
            <SingleSelect
              value={userResponse}
              options={options}
              setResponse={this.setResponse}
            />
          );
        case 'multiple_select':
          return (
            <MultipleSelect
              value={userResponse}
              options={options}
              setResponse={this.setResponse}
            />
          );
        case 'text_input':
          return <StringInput value={responseLink} />;
        default:
          return;
      }
    };
    return (
      <div
        className="font-mont custom-scrollbar overflow-y-scroll h-full"
        style={{ background: 'white', height: '100svh' }}
        ref={this.containerRef}
      >
        <div style={{ width: '100vw' }} className="w-full">
          <div
            className="p-24px relative"
            style={{
              background: 'var(--primary-button)',
              paddingTop: '40px',
            }}
          >
            <img
              src={crossIcon}
              height={'32px'}
              width={'32px'}
              alt={'back'}
              onClick={() =>
                this.props.history.push('/hra/exit', {
                  from: this.props?.location?.state?.from,
                })
              }
              style={{
                cursor: 'pointer',
                marginLeft: 'auto',
                backgroundColor: 'white',
                padding: '10px',
                borderRadius: '8px',
              }}
            />
            <p className="text-title-m font-bold text-textbox mb-16px">
              Section{' '}
              {currentQuestion.currentProgress.totalSections -
                currentQuestion.currentProgress.remainingSections}
              /
              <span className="text-chip text-customFFEA5A">
                {currentQuestion.currentProgress.totalSections}
              </span>
            </p>
            <ProgressBar
              width={`${progress}%`}
              height="10px"
              gradient={['#fff', '#fff']}
            />
            {this.props.config.hraLogo && this.props.config.showUpdatedHra ? (
              <img
                src={this.props.config.hraLogo}
                style={{
                  height: '60px',
                  borderRadius: '10px',
                  position: 'absolute',
                  right: '24px',
                }}
                alt={'logo'}
              />
            ) : (
              ''
            )}
            <div className="flex flex-row justify-between pt-20px">
              <p className="text-title-xl font-bold text-textbox mb-16px">
                {title}
              </p>
              <p className="text-title-s font-bold text-textbox mb-16px">
                Question{' '}
                {currentQuestion.currentProgress.totalQuestions -
                  currentQuestion.currentProgress.remainingQuestions}
                /
                <span className="text-chip text-customFFEA5A">
                  {currentQuestion.currentProgress.totalQuestions}
                </span>
              </p>
            </div>
            {currentQuestion.hraFitcoinStatus &&
              currentQuestion.hraFitcoinStatus.fitcoinAvailable && (
                <p className="text-title-s font-medium text-textbox mb-20px font-mont">
                  Answer this section to win{' '}
                  <span className="text-customFFEA5A">
                    {currentQuestion.currentProgress.perSectionReward} FIT Coins
                  </span>
                </p>
              )}
            {currentQuestion.hraFitcoinStatus &&
            currentQuestion.hraFitcoinStatus.earnedFitcoin > 0 &&
            currentQuestion.hraFitcoinStatus.remaining === 0 ? (
              <p className="text-title-s font-medium text-textbox mb-20px font-mont">
                You have earned{' '}
                <span className="text-customFFEA5A">
                  {currentQuestion.hraFitcoinStatus.earnedFitcoin} FIT Coins
                </span>
              </p>
            ) : (
              ''
            )}
          </div>
          <p className="text-title-m font-semibold text-txtlight mb-0px p-24px">
            {text}
          </p>
          <BodyContainer className="p-24px pt-0px overflow-y-auto">
            {renderResponse()}
            {info ? (
              <div className="mt-24px">
                <div
                  className="text-body-s flex flex-row font-medium btn p-0"
                  data-toggle="collapse"
                  role="button"
                  aria-expanded="false"
                  aria-controls="info"
                  onClick={() => {
                    this.setState({
                      showInfo: !showInfo,
                    });
                  }}
                  style={{
                    color: 'var(--primary-button)',
                  }}
                >
                  <p>See Information</p>
                  <img
                    src={arrowUpWhite}
                    style={{
                      transform: showInfo ? 'rotate(0deg)' : 'rotate(180deg)',
                      marginLeft: '5px',
                    }}
                    alt={'down'}
                  />
                </div>
                {showInfo ? (
                  <div className="collapse mt-12px" id="info">
                    <p className="text-txtsecondary font-medium text-body-s">
                      {info}
                    </p>
                  </div>
                ) : (
                  ''
                )}
              </div>
            ) : (
              ''
            )}
          </BodyContainer>
        </div>
        <ButtonsContainer>
          <PrimaryButton
            color=" #F5F4FF"
            onTap={this.goToPrevious}
            className="hra-button"
          >
            <div className="flex flex-row  items-center">
              {' '}
              <img
                src={backIcon}
                alt="back"
                style={{
                  height: '16px',
                  width: '16px',
                }}
              />
              <p className="ml-12px text-body-l text-txtlight font-semibold">
                Back
              </p>
            </div>
          </PrimaryButton>
          <PrimaryButton
            color="var(--primary-button)"
            onTap={() => {
              if (
                userResponse ||
                (this.state.stringResponse &&
                  this.state.stringResponse.trim().length > 0)
              ) {
                this.submitResponse();
                this.containerRef.current.scrollTo(0, 0);
              } else {
                return null;
              }
            }}
            className={`${
              userResponse ||
              (this.state.stringResponse &&
                this.state.stringResponse.trim().length > 0)
                ? ''
                : 'opacity-50'
            } hra-button`}
            style={{ borderRadius: '40px !important' }}
          >
            <div className={`flex flex-row text-textbox items-center`}>
              <p className="mr-12px text-body-l text-textbox font-semibold">
                Next
              </p>
              <img
                src={nextIcon}
                alt="back"
                style={{
                  height: '16px',
                  width: '16px',
                }}
              />{' '}
            </div>
          </PrimaryButton>
        </ButtonsContainer>
      </div>
    );
  }
}
const mapStateToProps = (state) => {
  return {
    config: state.app.config,
  };
};

export default connect(mapStateToProps)(HraQuestionContainer);
